// Same scale as the server's utils/general.js.
const STATUSES = {
  0: { label: "Nouveau", badge: "bg-gray-100 text-gray-800" },
  1: { label: "Lien envoyé", badge: "bg-blue-100 text-blue-800" },
  2: { label: "Visio démarrée", badge: "bg-yellow-100 text-yellow-800" },
  4: { label: "Clôturé", badge: "bg-green-100 text-green-800" },
};

const getStatus = (status) =>
  STATUSES[status] ? STATUSES[status].label : "Inconnu";

const getStatusBadgeClass = (status) =>
  STATUSES[status] ? STATUSES[status].badge : "bg-gray-100 text-gray-800";

const getTypeHistorical = (type) => {
  switch (type) {
    case 1:
      return "Création";
    case 2:
      return "Modification";
    case 3:
      return "Modification";
    case 4:
      return "SMS envoyé";
    case 5:
      return "Mail envoyé";
    case 6:
      return "Visioconférence";
    case 7:
      return "Visioconférence";
    case 8:
      return "Photo";
    case 9:
      return "Enregistrement";
    default:
      return "Inconnu";
  }
};

const companies = [
  { value: 0, name: "AUTRE" },
  { value: 1, name: "ALLIANZ" },
  { value: 2, name: "COVEA" },
  { value: 3, name: "MACIF" },
  { value: 5, name: "ACM" },
  { value: 6, name: "MACSF" },
  { value: 7, name: "MUTUELLE DE" },
  { value: 8, name: "MAIF" },
  { value: 9, name: "MATMUT" },
  { value: 10, name: "GAN" },
  { value: 11, name: "GROUPAMA" },
  { value: 12, name: "SWISSLIFE" },
  { value: 13, name: "ABEILLE" },
  { value: 14, name: "EQUITE" },
  { value: 15, name: "AREAS" },
  { value: 16, name: "GENERALI" },
  { value: 18, name: "MUTUELLE DES MOTARDS" },
  { value: 19, name: "AGPM" },
  { value: 20, name: "AXA" },
  { value: 21, name: "MFA" },
  { value: 22, name: "AVANSUR" },
  { value: 23, name: "SMACL" },
  { value: 24, name: "BPCE" },
  { value: 25, name: "SURAVENIR" },
  { value: 26, name: "AIOI" },
  { value: 27, name: "L'OLIVIER" },
  { value: 28, name: "MONCEAU" },
  { value: 29, name: "ALLIANZ OUTRE-MER'" },
  { value: 30, name: "GFA CARAÏBES" },
  { value: 31, name: "EUROFIL" },
  { value: 32, name: "ASSURANCE MUTUELLE D'OUTRE MER" },
  { value: 33, name: "MAPA" },
  { value: 34, name: "MCA" },
  { value: 35, name: "DEKRA" },
  { value: 36, name: "PROBUS INSURANCE" },
  { value: 37, name: "PRUDENCE CREOLE" },
  { value: 38, name: "HELVETIA ASSURANCES" },
];

const getCompaniesOptions = () => {
  let companiesOptions = [];
  companies.map((element, idx) => {
    companiesOptions.push({ text: element.name, value: element.value });
    return false;
  });
  return companiesOptions;
};

const getCompanyFromCode = (code) => {
  if (code === null || code === undefined || code === "") return "0";
  const numCode = Number(code);
  // Match direct par value (Code_Compagnie numérique)
  if (!isNaN(numCode)) {
    const found = companies.find((element) => element.value === numCode);
    if (found) return String(found.value);
  }
  // Fallback : match par nom
  let result = "0";
  companies.map((element) => {
    if (
      element.name &&
      element.name.toUpperCase().includes(String(code).toUpperCase())
    ) {
      result = String(element.value);
    }
    return false;
  });
  return result;
};

const getCompanyName = (id) => {
  let result = "AUTRE";
  const numId = Number(id);
  companies.map((element) => {
    if (element.value === numId) {
      result = element.name;
    }
    return false;
  });
  return result;
};

const getTimeSlotsOptions = () => {
  return [
    { text: "Sélectionner un créneau", value: "" },
    { text: "09:00", value: "09:00" },
    { text: "09:45", value: "09:45" },
    { text: "10:30", value: "10:30" },
    { text: "11:15", value: "11:15" },
    { text: "14:00", value: "14:00" },
    { text: "14:45", value: "14:45" },
    { text: "15:30", value: "15:30" },
    { text: "16:15", value: "16:15" },
  ];
};

export {
  getStatus,
  getStatusBadgeClass,
  getTypeHistorical,
  getCompaniesOptions,
  getCompanyFromCode,
  getCompanyName,
  getTimeSlotsOptions,
};
